import { render, staticRenderFns } from "./SalesYOY.vue?vue&type=template&id=ec222c74&scoped=true&"
import script from "./SalesYOY.vue?vue&type=script&lang=ts&"
export * from "./SalesYOY.vue?vue&type=script&lang=ts&"
import style0 from "./SalesYOY.vue?vue&type=style&index=0&id=ec222c74&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec222c74",
  null
  
)

export default component.exports